import { render } from "./ThresholdsList.vue?vue&type=template&id=5651d3c8&ts=true"
import script from "./ThresholdsList.vue?vue&type=script&lang=ts"
export * from "./ThresholdsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__